import {Elements, RecurlyProvider} from "@recurly/react-recurly";
import BuyItNow from "./BuyItNow";
import PropTypes from "prop-types";
import React from "react";

const BuyItNowContainer = ({
  contactFromSession,
  productDescriptor,
  recaptchaSiteKey,
  recurlyPublicKey,
  utmParams
}) => (
  <RecurlyProvider
    publicKey={recurlyPublicKey}
    required={["cvv"]}
  >
    <Elements>
      <BuyItNow
        contactFromSession={contactFromSession}
        productDescriptor={productDescriptor}
        recaptchaSiteKey={recaptchaSiteKey}
        utmParams={utmParams}
      />
    </Elements>
  </RecurlyProvider>
);

BuyItNowContainer.propTypes = {
  "contactFromSession": PropTypes.object,
  "productDescriptor": PropTypes.object.isRequired,
  "recaptchaSiteKey": PropTypes.string.isRequired,
  "recurlyPublicKey": PropTypes.string,
  "utmParams": PropTypes.object
};

BuyItNowContainer.defaultProps = {
  "contactFromSession": {},
  "recurlyPublicKey": "",
  "utmParams": {}
};

export default BuyItNowContainer;
